/* eslint-disable @typescript-eslint/no-explicit-any */
import { Table, Typography } from 'antd'
import { formatCurrency } from '../../../utils/currency'
import { CompletedPurchaseOrder } from '../../../types/purchaseOrder'

const { Text } = Typography

interface Props {
  items: CompletedPurchaseOrder['items']
}

export const CompletedOrderItemList: React.FC<Props> = ({ items }) => {
  console.log(items)
  const columns = [
    {
      title: 'Item',
      dataIndex: 'supplierItemCode',
      key: 'supplierItemCode',
      render: (_code: string, record: any) => (
        <div>
          {record.supplierItemCode && (
            <Text className="block text-sm">{record.supplierItemCode}</Text>
          )}
          {record.internalNotes && (
            <Text className="block text-sm">
              {record.internalNotes}
            </Text>
          )}
          <div>
            <Text type="secondary" className="block font-mono text-sm">
              {record.code}
            </Text>
          </div>
        </div>
      )
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'right' as const,
      render: (
        quantity: number,
        record: CompletedPurchaseOrder['items'][0]
      ) => {
        if ('unit' in record) {
          return (
            <Text>
              {quantity} {record.unit}
            </Text>
          )
        } else {
          return quantity
        }
      }
    },
    {
      title: 'Unit Price',
      dataIndex: 'costPrice',
      key: 'costPrice',
      align: 'right' as const,
      render: (price: number) => formatCurrency(price)
    },
    {
      title: 'Total',
      key: 'total',
      align: 'right' as const,
      render: (_: any, record: any) =>
        formatCurrency(record.quantity * record.costPrice)
    }
  ]

  const data = [
    ...items.map((item) =>
      item.type === 'lineItem'
        ? { ...item, key: item.id }
        : {
          ...item,
          key: item.id
        }
    )
  ]

  return (
    <Table
      columns={columns}
      dataSource={data}
      pagination={false}
      size="small"
    />
  )
}
